//正式服
module.exports = {
    //线上域名
  baseUrl: 'https://www.cleverplanting.com/',
  reviewBaseUrl: 'http://base.cleverplanting.com'
}
